import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, ElementRef } from '@angular/core';
import { QueryList } from '@angular/core';
import { Component, OnInit, ViewChildren } from '@angular/core';
import { HotToastService } from '@ngneat/hot-toast';
import { HttpErrorResponseMessages } from 'src/app/core/dtos/http-error-response-messages';
import { prepAudioData } from 'src/app/core/dtos/prep-audio-data';
import { AccountService } from 'src/app/core/services/account.service';
import { ConfigHelper } from 'src/app/core/services/helpers/config.helper';

@Component({
  selector: 'app-prep-audio-files',
  templateUrl: './prep-audio-files.component.html',
  styleUrls: ['./prep-audio-files.component.scss']
})
export class PrepAudioFilesComponent implements OnInit, AfterViewInit {
  @ViewChildren('audio') audioList: QueryList<ElementRef>;

  listOfProductAudio: prepAudioData[] = [];
  baseUrl = this.configHelper.getBaseUrl();

  constructor(
    private accountService: AccountService,
    private toastService: HotToastService,
    private configHelper: ConfigHelper,
  ) {
  }

  ngOnInit(): void {
    /*to add to the list just add another line with the order you want it to show up in, product id, and the group name header
    add corresponding folder to the "content/product-audio/" folder with the matching product number
    example     this.addProductAudioToList(2, 8106, "The CAEL Assessment Test Takers’ Preparation Guide, Volume III"); will need content/product-audio/8106*/
    this.addProductAudioToList(0, 8104, "The CAEL Assessment Test Takers’ Preparation Guide, Volume I");
    this.addProductAudioToList(1, 8105, "The CAEL Assessment Test Takers’ Preparation Guide, Volume II");
    this.addProductAudioToList(2, 8106, "The CAEL Assessment Test Takers’ Preparation Guide, Volume III");
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.audioList.forEach(audio => {
        const audioElement = audio.nativeElement as HTMLMediaElement;
        audioElement.onplay = () => {
          this.stopOtherAudios(audioElement.id);
        };
      });
    }, 1000);
  }

  addProductAudioToList(index: number, productId: number, header: string) {
    this.accountService.establishProductAudioLinks(productId)
      .subscribe(
        result => {
          const audioGroup: prepAudioData = {
            productId,
            productHeader: header,
            audioFilePaths: result.content,
            visible: false,
          };
          this.listOfProductAudio[index] = audioGroup;
        },
        (error: HttpErrorResponse) => {
          if (error.status === 400) {
            const errorMessage = error.error as HttpErrorResponseMessages;
            errorMessage.reasons.forEach(reasons => {
              this.toastService.warning(reasons.errorMessage);
            });
          }
        });

  }

  extractFileDisplayName(fileName: string) {
    const decodedFileName = decodeURIComponent(fileName.slice(0, -4));
    return decodedFileName.substring(decodedFileName.lastIndexOf('/') + 1);
  }

  stopOtherAudios(currentPlaying: string) {
    this.audioList.forEach(audio => {
      const audioElement = audio.nativeElement as HTMLMediaElement;
      if (!audioElement.paused && audioElement.id !== currentPlaying) {
        audioElement.pause();
      }
    });
  }

  toggleCollapse(groupNumber: number) {
    this.listOfProductAudio[groupNumber].visible = !this.listOfProductAudio[groupNumber].visible;
  }
}
